// extracted by mini-css-extract-plugin
module.exports = {"row_style":"ComparisonRow_row_style__1Bbpk","row_style_padding":"ComparisonRow_row_style_padding__3YN2s","empty_cells_placeholder":"ComparisonRow_empty_cells_placeholder__2k6hq"};